export { default as Edit } from 'exchange/components/list/actions/ExchangeActionEdit';



// WEBPACK FOOTER //
// src/modules/secured/modules/exchange/components/list/actions/index.js